import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import * as CatalogIndexActions from 'rebook/apps/catalog/actions/CatalogIndexActions';
import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';
import NicheCatalogBestsellers from 'rebook/apps/catalog/components/NicheCatalog/NicheCatalogBestsellers';

import styles from './style.scss';


class ContentNotFound extends React.Component {
  constructor(props) {
    super(props);
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(CatalogIndexActions.fetchInitialData(match));
  }

  componentWillMount() {
    this.props.CatalogIndexActions.fetchInitialData();
  }


  render() {
    const { bestsellersBookset, latestBooksets } = this.props.catalogIndex;
    const { booksPerSubscriptionCounter } = this.props;
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.text}>
            <span className={styles.icon} />
            <h1>Ошибка 404</h1>
            <p>
              Увы, по этому адресу ничего нет.
            </p>
            <p className={styles.supportText}>Ищете, что почитать?
              <br />Посмотрите популярные новинки, подборки и книжные новости!
            </p>
          </div>
          <NicheCatalogBestsellers
            title="Самое популярное"
            bestsellersBookset={bestsellersBookset}
            booksTotalCounter={booksPerSubscriptionCounter.total} />
          <BooksetsCarousel
            title="Последние подборки"
            booksets={get(latestBooksets, 'booksets', [])}
            booksetsCount={get(latestBooksets, 'totalCount', 0)}
            link="/sets/"
            linkText="Все подборки" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    catalogIndex: state.catalogIndex,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    CatalogIndexActions: bindActionCreators(CatalogIndexActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentNotFound);
